import { Controller } from "@hotwired/stimulus";
import Sortable from "sortablejs";

export default class extends Controller {
  static values = { path: String };

  connect() {
    this.sortable = new Sortable(this.element, {
      handle: ".sortable-handle",
      animation: 150,
      onEnd: this.updateOrder.bind(this),
    });
  }

  updateOrder() {
    const childIds = Array.from(this.element.querySelectorAll("li")).map(
      (item) => item.dataset.id
    );

    this.sendUpdateRequest(childIds);
  }

  sendUpdateRequest(childIds) {
    fetch(this.pathValue, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]').content,
      },
      body: JSON.stringify({ child_ids: childIds }),
    })
      .then((response) => response.json())
      .then((data) => this.handleUpdateResponse(data))
      .catch((error) => console.error("Update failed:", error));
  }

  handleUpdateResponse(data) {
    if (data.magazine_project_problems) {
      const problemsElement = document.getElementById("magazine-project-problems");
      if (problemsElement) {
        problemsElement.innerHTML = data.magazine_project_problems;
      }
    }
  }
}
